/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { TabComponent } from './tab';
export * from './tab-adapter';
export * from './tab-constants';
export * from './tab-core';
export * from './tab';
export function defineTabComponent() {
    defineCustomElement(TabComponent);
}
